import axios from 'axios';

export const save = async (data) => (
  await axios.get(
    'https://script.google.com/macros/s/AKfycbziYWOXqLJaxBkShAj1NNCdZUNJZwfVq4w50gRM9gqOdPJGqoM/exec',
    { params: data }
  )
);
